import React from 'react';
import { TbArrowLeft, TbArrowRight } from 'react-icons/tb';
import HandX from './Icons/HandX';

interface NavigateToCategoryArrowsProps {
    show: boolean;
    index: number;
    categoryPrevName: string;
    categoryNextName: string;
    showPrev: boolean;
    showNext: boolean;
    onClickCategory?: CallableFunction;
}

const NavigateToCategoryArrows = ({
    show,
    index,
    categoryPrevName,
    categoryNextName,
    showPrev,
    showNext,
    onClickCategory = () => {},
}: NavigateToCategoryArrowsProps) => {
    if (!show) return null;

    return (
        <section className='col-span-full py-4'>
            <div className='flex justify-between'>

                <div className='flex items-center gap-1 justify-center w-full' onClick={() => onClickCategory(index - 1)}>
                    <div className='flex text-sm items-center text-center gap-0.5 leading-4 text-gray-400'>
                        {showPrev && <>
                            <div><TbArrowLeft className="animate-drag-left text-gray-300" /></div>
                            <span className='font-bold text-left'>{categoryPrevName}</span>
                        </>}
                    </div>
                </div>

                <div className='w-full'>
                    <HandX className={`text-custom-primary`} size={55} />
                </div>

                <div className='flex items-center gap-1 justify-center w-full' onClick={() => onClickCategory(index + 1)}>
                    <div className='flex text-sm text-right items-center gap-0.5 leading-4 text-gray-400'>
                        {showNext && 
                            <>
                                <span className='font-bold'>{categoryNextName}</span>
                                <div><TbArrowRight className="animate-drag-right text-gray-300" /></div>
                            </>
                        }
                    </div>
                </div>

            </div>
        </section>
    )
}

export default NavigateToCategoryArrows;